"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggerBuilder = void 0;

var _auth = require("@nextcloud/auth");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LoggerBuilder = /*#__PURE__*/function () {
  function LoggerBuilder(factory) {
    _classCallCheck(this, LoggerBuilder);

    this.context = {};
    this.factory = factory;
  }

  _createClass(LoggerBuilder, [{
    key: "setApp",
    value: function setApp(appId) {
      this.context.app = appId;
      return this;
    }
  }, {
    key: "setUid",
    value: function setUid(uid) {
      this.context.uid = uid;
      return this;
    }
  }, {
    key: "detectUser",
    value: function detectUser() {
      var user = (0, _auth.getCurrentUser)();

      if (user !== null) {
        this.context.uid = user.uid;
      }

      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return this.factory(this.context);
    }
  }]);

  return LoggerBuilder;
}();

exports.LoggerBuilder = LoggerBuilder;
//# sourceMappingURL=LoggerBuilder.js.map